import { render, staticRenderFns } from "./OrderPropertyValueList.vue?vue&type=template&id=2d8aca16"
import script from "./OrderPropertyValueList.vue?vue&type=script&lang=js"
export * from "./OrderPropertyValueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports